import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { Modal, ButtonToolbar, Button } from 'react-bootstrap'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { history } from '../../../Routing'
import { getPaymentPrefillFormSchema, getUIPaymentPrefillFormSchema } from '../../../Model/PaymentPrefillForm'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import HttpActionsService from '../../../Services/HttpActionsService'
import { PaymentStatus, PaymentSource, PaymentType, PaymentDirection } from '../../../Model/Payment'

export interface IPaymentCreateParams {
    httpActionsService?: HttpActionsService
    localizationStore?: LocalizationStore
}

@inject('httpActionsService')
@inject('localizationStore')
@observer
export default class PaymentCreateView extends React.Component<IPaymentCreateParams> {

    constructor(props: any) {
        super(props)
        this.state = {
            show: false
        }
    }

    showModal() {
        this.setState({ show: true })
    }

    handleClose(e: any, context: PaymentCreateView) {
        context.setState({ show: false })
    }

    handleOk(e: ISubmitEvent<any>, context: PaymentCreateView) {

        this.props.httpActionsService!.getCurrentNotPaidPenalty(e.formData['creditNumberPaymentPrefill'])

        this.props.httpActionsService!.getQuestionnaireByCreditNumAndSource(
            e.formData['creditNumberPaymentPrefill'],
            e.formData['externalDataSourceType'],
            e.formData['amountPrefill'],
            PaymentStatus.Done,
            e.formData['paymentSource'],
            e.formData['paymentDateTime'],
            e.formData['paymentType'],
            e.formData['paymentDirection'])
            
        history.push('/payment')

        context.setState({ show: false })
    }

    render() {
        const { localizationStore } = this.props
        return (
            <div>
                <Modal
                    show={this.state['show']}
                    onHide={() => { return this.handleClose({}, this) }}
                    animation={false}
                    keyboard={false}
                    backdrop={true}
                >
                    <div className="formWrapper payment-create-form">
                        <Form
                            onSubmit={(e) => { this.handleOk(e, this) }}
                            schema={getPaymentPrefillFormSchema()}
                            uiSchema={getUIPaymentPrefillFormSchema()}
                            formData={{
                                paymentStatus: PaymentStatus.Done,
                                paymentSource: PaymentSource.Cash,
                                paymentDateTime: new Date().toISOString(),
                                paymentType: PaymentType.MonthlyPayment,
                                paymentDirection: PaymentDirection.Deposit
                            }}
                        >
                            <ButtonToolbar>
                                <Button
                                    bsStyle="link"
                                    onClick={(e) => { return this.handleClose(e, this) }}
                                >
                                    {localizationStore!.t!('Cancel')}
                                </Button>
                                <Button
                                    type="submit"
                                    bsStyle="success"
                                >
                                    {localizationStore!.t!('Create')}
                                </Button>
                            </ButtonToolbar>
                        </Form>
                    </div>
                </Modal>
                <Button
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={localizationStore!.t!('Add payment')}
                    className="create-btn"
                    onClick={() => this.showModal()}
                    data-html="true"
                >
                    {localizationStore!.t!('Add payment')}
                </Button>
                <Button
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={localizationStore!.t!('Add payment')}
                    className="create-btn closed"
                    onClick={() => this.showModal()}
                    data-html="true"
                >
                    $
                </Button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Payment/PaymentCreateView.tsx